
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import StreetCustomer from "../components/streetdetails";
import Footer from "../components/footer";

function StreetCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <StreetCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default StreetCustomerPage;
